import Cart from "../../components/features/cart/Cart";

const CartPage = () => {
  return <Cart />;
};

export default CartPage;
